import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=35ae4c21"
import script from "./infos.vue?vue&type=script&lang=ts"
export * from "./infos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports